// extracted by mini-css-extract-plugin
export var card = "_72-1";
export var container = "_72-0";